import React from 'react'
import {
  Box,
  Typography,
  Grid
} from '@material-ui/core'
import { components } from 'cng-web-lib'

const {
  button: { CngPrimaryButton },
  CngDialog
} = components

function ErrorDialog({
  open,
  onClose,
  title = 'Error',
  message = 'An unknown error occurred.',
  buttonText = 'Ok'
}) {
  return (
    <CngDialog
      dialogContent={
        <Box>
          <Grid
            container
            spacing={2}
            justify='center'
            alignItems='center'
          >
            <Grid item xs={12}>
              <Box>
                <Typography
                  variant='body2'
                  style={{ whiteSpace: 'pre-line' }}
                >
                  {message}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container justify='center'>
            <Box mt={1}>
              <CngPrimaryButton onClick={onClose}>
                {buttonText}
              </CngPrimaryButton>
            </Box>
          </Grid>
        </Box>
      }
      dialogTitle={title}
      open={open}
      onClose={() => { }}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      maxWidth='sm'
    />
  )
}

export default ErrorDialog